export const GenderType = {
    Mujer: 'F',
    Hombre: 'M',
    null: 'null'
};